import React, { useContext, useEffect, useState } from 'react'
import { Alert, Button, DatePicker, Form, Input, message } from 'antd'
import { getRequestAuth, postRequestAuth, putRequestAuth } from '../../../request/request';
import moment from 'moment';
import { AppContext } from '../../../App';
import { ContextType } from '../../../type/type';
import { useTranslation } from 'react-i18next';
import validatorServerErrors from '../../../modules/ValidatorServerErrors/ValidatorServerErrors';
import { JWT, ME } from '../../../reduser/Reduser';
import { useLocation, useNavigate } from 'react-router-dom'
import { validateAge } from '../../../function/validateAge';
import '../style/styleProfile.scss'
import BottomMenuInfo from '../../../modules/BottomMenuInfo/BottomMenuInfo';

type FieldType = {
  username?: string
  password?: string
  remember?: string
}

const Personal = () => {
  const { state, dispatch, isMobileWidth } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const [about_me] = Form.useForm();
  const [form_phone] = Form.useForm()
  const [form_email] = Form.useForm()
  const [form_password] = Form.useForm()
  const [form_change_phone] = Form.useForm()
  const [userId, setUserId] = useState(null)
  const [dateBirthday, setDateBirthday] = useState(null)
  const [userPhone, setUserPhone] = useState(null)
  const [reload, setReload] = useState(false)
  const [validateErrors, setValidateErrors]: any = useState({})
  const [isLoading, setLoading] = useState(false)
  const [step, setStep] = useState(1)
  const dateFormat = 'YYYY-MM-DD'
  const dateFormatCalendar = ['YYYY-MM-DD', 'DD.MM.YYYY']
  const navigate = useNavigate()

  useEffect(() => {
    getRequestAuth('/profile/about_me/')
      .then((res: any) => {
        const {
          first_name,
          last_name,
          middle_name,
          date_birthday,
          user: { id, phone, email },
        } = res?.data || {}

      const newDate: any = moment(date_birthday, dateFormat)

      setUserId(id)
      setDateBirthday(date_birthday)

      about_me.setFieldsValue({
        first_name,
        last_name,
        middle_name,
        date_birthday: date_birthday ? newDate : '',
      })

      form_email.setFieldsValue({
        email,
      })

      setUserPhone(phone)
      form_phone.setFieldsValue({
        phone,
      })
    })
    .catch((err) => {
      validatorServerErrors(err.data)
      dispatch({
        type: JWT,
        payload: null,
      })
      navigate('/cabinet')
    })
  }, [reload, state.lang])

  const onFinishFailed = (errorInfo: any) => {
    console.log('errorInfo', errorInfo)
  }

  const disabledDate = (current: any) => {
    const minDate = new Date(1900, 0, 1)
    const maxDate = moment()
    return current && (current < minDate || current > maxDate)
  }

  const convertDate = (value: any) => {
    return moment(value).format(dateFormat)
  }
    
  const onFinish = (values: any, type: string) => {
    console.log(type)
    setLoading(true)
  
    if (type === 'about_me') {
      const date_birthday = values.date_birthday ? convertDate(values.date_birthday) : null;
      const last_name = values.last_name;
  
      if (last_name) {
        putRequestAuth('/profile/update_profile/', { ...values, user: userId, date_birthday })
          .then(() => {
            setStep(1)
            setLoading(false)
            message.success(t('h80'))
            setValidateErrors(null)
            setReload((e: boolean) => !e)
            dispatch({
              type: ME,
              payload: { ...state.me, is_verified: true },
            })
          })
          .catch((err) => {
            setLoading(false)
            validatorServerErrors(err.data, setValidateErrors)
          })
      } else {
        postRequestAuth('/profile/create_profile/', { ...values, user: userId, date_birthday })
          .then(() => {
            setStep(1)
            setLoading(false)
            message.success(t('h80'))
            setValidateErrors(null)
            setReload((e: boolean) => !e)
            dispatch({
              type: ME,
              payload: { ...state.me, is_verified: true },
            })
          })
          .catch((err) => {
            setLoading(false)
            validatorServerErrors(err.data, setValidateErrors)
          })
        }
      }
    }

  return (
    <>
     { isMobileWidth && <h3 className='profile-title'>{t('h76')}</h3> }
      <Form
        form={about_me}
        name="basic"
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={(e) => onFinish(e, 'about_me')}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item<FieldType>
          label={t('h61')}
          name="last_name"
          className='profile-form-item'
          rules={[
            { required: true, message: `${t('h48')} ${t('h67')}` },
            { max: 30, message: `${t('h171')}: 30` },
          ]}
          validateStatus={validateErrors?.last_name ? 'error' : ''}
          help={validateErrors?.last_name}
        >
          <Input />
        </Form.Item>

        <Form.Item<FieldType>
          label={t('h62')}
          name="first_name"
          rules={[{ max: 30, message: `${t('h171')}: 30` }]}
          validateStatus={validateErrors?.first_name ? 'error' : ''}
          help={validateErrors?.first_name}
        >
          <Input />
        </Form.Item>

        <Form.Item<FieldType>
          label={t('h63')}
          name="middle_name"
          rules={[{ max: 30, message: `${t('h171')}: 30` }]}
          validateStatus={validateErrors?.middle_name ? 'error' : ''}
          help={validateErrors?.middle_name}
        >
          <Input />
        </Form.Item>

        <Form.Item<FieldType>
          label={t('h65')}
          name="date_birthday"
          rules={[
            { required: false, message: `${t('h48')} ${t('h65')}` },
            {
              validator: (_, value) => validateAge(value, 18, t),
            },
          ]}
          validateStatus={validateErrors?.date_birthday ? 'error' : ''}
          help={validateErrors?.date_birthday}
        >
          <DatePicker
            showToday={false}
            placeholder={t('h87')}
            format={dateFormatCalendar}
            style={{ width: isMobileWidth ? '100%' : 200 }}
            disabledDate={disabledDate}
          />
        </Form.Item>

        <div className="text-center">
          <Button type="primary" htmlType="submit" className={ isMobileWidth ? 'mobile-button-submit' : 'color_btn'}>
            {t('h81')}
          </Button>
        </div>
      </Form>
      { isMobileWidth && <BottomMenuInfo type="man" /> }
    </>
    )
}

export default Personal
